import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';

const NOTE_PLACEHOLDER = 'Type your note here...';

const NoteInput = ({
  noteText, onNoteChange, onClose, ruleId,
}) => {
  const textareaRef = useRef(null);

  const adjustHeight = () => {
    const el = textareaRef.current;
    if (el) {
      el.style.height = 'auto';
      el.style.height = `${el.scrollHeight}px`;
    }
  };

  useEffect(() => {
    adjustHeight();
  }, [noteText]);

  return (
    <div className='note-input-container'>
      <textarea
        ref={textareaRef}
        placeholder={NOTE_PLACEHOLDER}
        value={noteText}
        onChange={e => onNoteChange(e.target.value)}
        rows={2}
        data-testid={`note-textarea-${ruleId}`}
      />
      <button
        type='button'
        aria-label='Close'
        className='close-note-button'
        onClick={onClose}
        data-testid={`note-close-${ruleId}`}
      >
        <Icon name='close' aria-hidden='true' />
      </button>
    </div>
  );
};

NoteInput.propTypes = {
  noteText: PropTypes.string.isRequired,
  onNoteChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  ruleId: PropTypes.string.isRequired,
};

export default NoteInput;
